import { render, staticRenderFns } from "./ObjectiveData.vue?vue&type=template&id=4b272ef0&scoped=true"
import script from "./ObjectiveData.vue?vue&type=script&lang=js"
export * from "./ObjectiveData.vue?vue&type=script&lang=js"
import style0 from "./ObjectiveData.vue?vue&type=style&index=0&id=4b272ef0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b272ef0",
  null
  
)

export default component.exports